module.exports = __webpack_public_path__ + "assets/img/avatar.dce7bcd4.png";